import type { User } from "types/User";

// "First Last", or whichever of the two is filled in, or "" when neither is
export const getSignatureName = (
    user: Pick<User, "firstName" | "lastName"> | null,
): string => {
    const nameParts = [user?.firstName, user?.lastName]
        .map((namePart) => namePart?.trim() ?? "")
        .filter((namePart) => namePart !== "");

    return nameParts.join(" ");
};
